import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { GroupService } from './group.service';
import { PatientService } from './patient.service';

/**
 * Switches the selected practice. A patient from the old practice is closed first and the switch
 * waits for that, so no screen is left showing or saving one practice's patient under another.
 */
@Injectable({
  providedIn: 'root'
})
export class PracticeSwitchService {

  constructor(
    private groupService: GroupService,
    private patientService: PatientService,
    private router: Router,
  ) { }

  /** False when a running recording holds the practice in place. */
  async switchTo(group: any): Promise<boolean> {
    if (this.patientService.isRecordingLocked()) return false;

    const current = this.groupService.group;
    const changing = !!current && String(current.id).toLowerCase() !== String(group?.id).toLowerCase();
    if (changing) {
      this.patientService.setCurrentPatient(null);
      await this.router.navigate(['/patients', { outlets: { patient: null } }]);
    }
    this.groupService.setSelectedGroup(group);
    return true;
  }
}
